import React from "react";

const PaymentRefund = () => {
  document.title = "Refund policy";

  return (
    <>
      <div className="container my-5">
        <h5>
          At Yuvasarathi, we understand that circumstances may change, and
          sometimes, you may need to cancel your payment. Please read our
          cancellation and refund policy carefully to understand your options.
        </h5>

        <ol>
          <li>
            <b> Cancellation Window: </b>Registrations for our events can be
            canceled up to [X] days prior to the event date. After this period,
            cancellations may not be eligible for a refund.
          </li>
          <li>
            <b> How to Initiate a Cancellation:</b> To initiate a cancellation,
            please send an email to [Your Contact Email Address] with the
            subject line "Event Cancellation - [Event Name]." Please include
            your full name, event registration details, and reason for
            cancellation in the email.
          </li>
          <li>
            <b> Refund Processing Time:</b> Once we receive your cancellation
            request, we will process your refund within [X] business days.
            Please note that it may take additional time for the refunded amount
            to reflect in your account, depending on your financial institution.
          </li>
          <li>
            <b> Event Cancellation by Yuvasarathi: </b>In the unlikely event
            that we need to cancel an event, we will notify registered
            participants via email and/or phone as soon as possible. If we
            cancel an event, registered participants will have the option to
            receive a full refund or transfer their registration to a future
            event, subject to availability.
          </li>
          <li>
            <b> No-Show Policy:</b> If you are unable to attend an event and do
            not cancel your registration within the specified cancellation
            window, you may be considered a no-show, and no refund will be
            provided.
          </li>

          <li>
            <b> Exceptional Circumstances:</b> We understand that certain
            exceptional circumstances may arise that prevent you from attending
            an event. In such cases, please contact us directly to discuss your
            situation, and we will do our best to accommodate your request. By
            registering for an event with Yuvasarathi, you agree to abide by the
            terms and conditions of this cancellation and refund policy.
          </li>
          <p className="my-3">
            For any inquiries or assistance regarding event cancellations and
            refunds, please contact us at &nbsp;
            <a href="mailto:yuvasarathi24@gmail.com">yuvasarathi24@gmail.com</a>
            &nbsp; or <b>9371001138</b>.
          </p>
        </ol>
      </div>
    </>
  );
};

export default PaymentRefund;
